<script setup lang="ts">
import type { Emit, Props } from '../model/types';
import { ButtonQC } from '@qicgroupdoha/qic-connect-ds';
import { onMounted } from 'vue';
import { useRoute } from 'vue-router';
import { useRenewQuoteStore } from '@/entities/Stores/RenewQuote';
import { GetInTouch } from '@/features/GetInTouch';
import { GA_EVENTS, useGoogleAnalytics } from '@/shared/analytics';
import { usePushEvent } from '@/shared/composables';
import { FlowCard } from '@/shared/ui/FlowCard';
import { ErrorStateIcon } from '@/shared/ui/icons';

const props = defineProps<Props>();
const emit = defineEmits<Emit>();

const route = useRoute();
const pushEvent = usePushEvent();
const gaService = useGoogleAnalytics();
const renewQuoteStore = useRenewQuoteStore();

function clickHandler() {
  gaService.send(GA_EVENTS.TRY_AGAIN, {
    product: 'renewal',
    title: 'Failed to load',
    text: 'Try again or contact us if the problem continues',
    error_code: props.error.code,
    product_code: renewQuoteStore.selectedScheme?.productcode,
    policy_id: renewQuoteStore.details?.policyNumber,
  });

  emit('resolve');
}

onMounted(() => {
  gaService.send(GA_EVENTS.ERROR_PAGE, {
    product: 'renewal',
    title: 'Failed to load',
    text: 'Try again or contact us if the problem continues',
    error_code: props.error.code,
    product_code: renewQuoteStore.selectedScheme?.productcode,
    policy_id: renewQuoteStore.details?.policyNumber,
  });

  // TODO: should be ERROR_PAGE
  pushEvent(GA_EVENTS.VIEW_PAGE, route, {
    policyNumber: renewQuoteStore.details?.policyNumber,
    quoteNumber: renewQuoteStore.quoteNumber,
    errorCode: props.error.code,
    errorMessage: props.error.message,
  });
});
</script>

<template>
  <FlowCard controls-off>
    <div class="failed-to-load">
      <div class="failed-to-load__img">
        <ErrorStateIcon />
      </div>
      <b class="failed-to-load__title">{{ $t('renew.error_page.headers.failed_to_load') }}</b>
      <p class="failed-to-load__text">
        {{ $t('renew.error_page.subtitles.text5') }}
      </p>
      <ButtonQC class="failed-to-load__btn" @click="clickHandler">
        {{ $t('renew.error_page.try_again.button') }}
      </ButtonQC>
      <GetInTouch />
    </div>
  </FlowCard>
</template>

<style scoped lang="scss">
@use 'FailedToLoad';
</style>
